import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import { useSelector } from 'react-redux';
import { DSTheme } from '../../styles/themes/types';
import TableRow from '../Table/TableRow/TableRow';
import { IUser } from '../../interfaces/user';
import UserLogo from '../../assets/UserLogo';
import ProjectStack from '../Projects/ProjectStack';
import COLOURS from '../../constants/colours';
import {
  selectProjectOrganisationById,
  selectProjectsByOrganisationId,
} from '../../redux/selectors/adminProjects';

const useStyles = makeStyles((theme: DSTheme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 1fr)',
    alignItems: 'center',
    width: '100%',
    gap: '10px',
    paddingBottom: '16px',

    [theme.breakpoints.up('md')]: {
      height: '104px',
      gridTemplateColumns: '0.5fr 1fr 1.5fr 1fr',
      gap: '0',
      paddingBottom: '0',
    },
  },
  tableRowContent: {
    width: '100%',
    height: '100%',
    boxShadow: 'inset 0px -1px 0px #808191;',
  },
  developerName: {
    fontWeight: 700,
  },
  companyName: {
    color: theme.palette.grey[700],
    fontSize: '12px',
    marginTop: '8px',
  },
}));

type UserTableRowProps = {
  developer: IUser;
  onClick: (projectId: string) => void;
  index: number;
};

const logoColors = [COLOURS.lightBlue, COLOURS.pink, COLOURS.turquoise];

const UserTableRow: React.FC<UserTableRowProps> = ({ developer, onClick, index }) => {
  const classes = useStyles();
  const organisation = useSelector(selectProjectOrganisationById(developer.organisationId));
  const projects = useSelector(selectProjectsByOrganisationId(developer.organisationId));
  const formattedDate = format(new Date(developer.dateUpdated as string), 'dd MMMM yyyy, HH:mm');

  function getLogoColor() {
    return logoColors[index % logoColors.length];
  }

  return (
    <TableRow>
      <div role="row" className={classes.root}>
        <UserLogo fill={getLogoColor()} />

        <div>
          <Typography variant="body1" className={classes.developerName}>
            {developer.username}
          </Typography>

          <Typography variant="body2" className={classes.companyName}>
            {organisation?.name || ''}
          </Typography>
        </div>

        <ProjectStack projects={projects} onClick={onClick} />
        <Typography variant="body2">{formattedDate}</Typography>
      </div>
    </TableRow>
  );
};

export default UserTableRow;
